(function () {
  if (window.__gfOrderBound) return;
  window.__gfOrderBound = true;

  var MODE_KEY = "gf-order-mode";
  var ZIP_KEY = "gf-order-zip";
  var PLACE_KEY = "gf-order-place";
  var ATTR_MODE = "Bestellart";
  var ATTR_ZIP = "Liefer-PLZ";
  var ATTR_PLACE = "Lieferort";
  var DEFAULT_DELIVERY_AREA = {
    "97199": ["Ochsenfurt"],
    "97218": ["Gerbrunn"],
    "97228": ["Rottendorf"],
    "97236": ["Randersacker"],
    "97246": ["Eibelstadt"],
    "97252": ["Frickenhausen am Main"],
    "97279": ["Prosselsheim"],
    "97286": ["Sommerhausen", "Winterhausen"],
    "97288": ["Theilheim"],
    "97318": ["Kitzingen", "Biebelried"],
    "97320": ["Albertshofen", "Buchbrunn", "Großlangheim", "Mainstockheim", "Sulzfeld am Main"],
    "97334": ["Sommerach", "Nordheim am Main"],
    "97337": ["Dettelbach"],
    "97340": ["Marktbreit", "Martinsheim", "Segnitz"],
    "97342": ["Marktsteft", "Obernbreit", "Seinsheim"],
    "97346": ["Iphofen"],
    "97348": ["Rödelsee", "Markt Einersheim", "Willanzheim"],
    "97350": ["Mainbernheim"],
    "97353": ["Wiesentheid"],
    "97355": ["Kleinlangheim", "Wiesenbronn", "Castell", "Abtswind", "Rüdenhausen"],
    "97359": ["Schwarzach am Main"]
  };
  var LEGACY_ZIP_VALUES = {
    "nicht gesetzt (Abholung)": true,
    "noch nicht angegeben": true
  };
  var cartSeq = 0;
  var lineSeq = {};
  var railSyncTimer = 0;
  var noteTimer = 0;
  var invalidateZipTimer = 0;
  var checkoutHandoff = false;
  var cartPending = 0;
  var MODE_CHOSEN_KEY = "gf-order-mode-chosen";

  function fromEvent(event) {
    var node = event.target;
    if (node && node.nodeType === 3) node = node.parentElement;
    return node && node.closest ? node : null;
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function config() {
    return window.gfOrder || {};
  }

  function settings() {
    return config().settings || {};
  }

  function routes() {
    var cfg = config().routes || {};
    var root = cfg.root || (window.theme && theme.rootUrl) || "/";
    if (root === "/") root = "";
    else root = String(root).replace(/\/$/, "");
    return {
      cartJs: cfg.cartJs || root + "/cart.js",
      cartAddJs: cfg.cartAddJs || root + "/cart/add.js",
      cartChangeJs: cfg.cartChangeJs || root + "/cart/change.js",
      cartUpdateJs: cfg.cartUpdateJs || root + "/cart/update.js",
      searchSuggest: cfg.searchSuggest || root + "/search/suggest.json"
    };
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function formatMoney(cents) {
    var format = (window.theme && theme.moneyFormat) || "{{amount_with_comma_separator}} €";
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, format);
    }
    var number = Math.abs(Number(cents) || 0) / 100;
    var formatted = number.toFixed(2).replace(".", ",");
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(format)) {
      return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted);
    }
    if (/\{\{\s*amount\s*\}\}/.test(format)) {
      return format.replace(/\{\{\s*amount\s*\}\}/, number.toFixed(2));
    }
    return formatted + " €";
  }

  function parseJSONResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text) {
        try { data = JSON.parse(text); } catch (error) {
          var parseError = new Error("Die Shop-Antwort konnte nicht gelesen werden.");
          parseError.status = response.status;
          throw parseError;
        }
      }
      if (!response.ok) {
        var message = (data && (data.description || data.message)) || "Die Anfrage ist fehlgeschlagen.";
        if (typeof message !== "string") message = "Die Anfrage ist fehlgeschlagen.";
        var error = new Error(message);
        error.status = response.status;
        error.payload = data;
        throw error;
      }
      return data;
    });
  }

  function fetchJSON(url, body) {
    var opts = {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      }
    };
    if (body) {
      opts.method = "POST";
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(parseJSONResponse);
  }

  function fetchForm(url, params) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: params.toString()
    }).then(parseJSONResponse);
  }

  function getCart() {
    return fetchJSON(routes().cartJs);
  }

  function scheduleRailSync() {
    window.clearTimeout(railSyncTimer);
    railSyncTimer = window.setTimeout(function () {
      getCart().then(applyCartState).catch(function () {});
    }, 400);
  }

  function neutralizeExpressHeader() {
    var main = qs("[data-main-content]");
    if (main && main.style.paddingTop && main.style.paddingTop !== "0px") {
      main.style.setProperty("padding-top", "0px", "important");
    }
    var headerWrap = qs(".header-wrapper");
    if (headerWrap) {
      if (headerWrap.classList.contains("header-wrapper--hidden") || headerWrap.classList.contains("header-wrapper--fixed")) {
        headerWrap.classList.remove("header-wrapper--hidden", "header-wrapper--fixed");
      }
      if (headerWrap.style.transform && headerWrap.style.transform !== "none") {
        headerWrap.style.setProperty("transform", "none", "important");
      }
      if (headerWrap.style.position !== "fixed") {
        headerWrap.style.setProperty("position", "fixed", "important");
      }
    }
    var sentinel = qs("[data-sticky-sentinel-header]");
    if (sentinel && sentinel.style.transform) {
      sentinel.style.transform = "none";
    }
    qsa(".menu-navigation-wrapper").forEach(function (nav) {
      if (nav.classList.contains("menu-navigation-wrapper--hidden")) {
        nav.classList.remove("menu-navigation-wrapper--hidden");
      }
    });
    document.body.classList.remove("body-with-sticky-header");
  }

  function stripInjectedCheckoutWidgets() {
    return;
  }

  function watchInjectedCheckoutWidgets() {
    return;
  }

  function watchExpressHeader() {
    neutralizeExpressHeader();
    if (watchExpressHeader.mo || !window.MutationObserver) return;
    var headerWrap = qs(".header-wrapper");
    var main = qs("[data-main-content]");
    watchExpressHeader.mo = new MutationObserver(function () {
      neutralizeExpressHeader();
    });
    if (headerWrap) {
      watchExpressHeader.mo.observe(headerWrap, { attributes: true, attributeFilter: ["class", "style"] });
    }
    if (main) {
      watchExpressHeader.mo.observe(main, { attributes: true, attributeFilter: ["style"] });
    }
  }

  function updateOffsets() {
    neutralizeExpressHeader();
    var header = qs(".header-wrapper");
    var nav = qs(".gf-menu__nav");
    var root = document.documentElement;
    var preview = document.getElementById("preview-bar-iframe")
      || document.getElementById("admin-bar-iframe")
      || qs(".preview-bar-iframe")
      || qs("#PBarNextFrame");
    var admin = preview ? Math.round(preview.getBoundingClientRect().height) : 0;
    root.style.setProperty("--gf-admin-offset", admin + "px");
    if (header) root.style.setProperty("--gf-header-offset", header.offsetHeight + "px");
    if (nav) root.style.setProperty("--gf-nav-offset", nav.offsetHeight + "px");
  }

  function currentMode() {
    var saved = null;
    try { saved = localStorage.getItem(MODE_KEY); } catch (error) {}
    var attr = ((config().attributes || {})[ATTR_MODE]) || "";
    if (attr === "Abholung") return "pickup";
    if (attr === "Lieferung") return "delivery";
    return saved === "pickup" ? "pickup" : "delivery";
  }

  function isPlaceholderZip(value) {
    var zip = String(value || "");
    return !zip || LEGACY_ZIP_VALUES[zip] === true || !/^\d{5}$/.test(zip);
  }

  function pickupCity() {
    return settings().pickupCity || (config().shop && config().shop.city) || "Kitzingen";
  }

  function storedValue(key) {
    try { return localStorage.getItem(key) || ""; } catch (error) { return ""; }
  }

  function storedSet(key, value) {
    try {
      if (value) localStorage.setItem(key, value);
      else localStorage.removeItem(key);
    } catch (error) {}
  }

  function currentZip() {
    var attr = ((config().attributes || {})[ATTR_ZIP]) || "";
    if (!isPlaceholderZip(attr)) return attr;
    var saved = storedValue(ZIP_KEY);
    if (!isPlaceholderZip(saved)) return saved;
    return "";
  }

  function currentPlace() {
    var attr = ((config().attributes || {})[ATTR_PLACE]) || "";
    if (attr) return String(attr);
    return storedValue(PLACE_KEY);
  }

  function zipInputValue() {
    var fromField = "";
    qsa("[data-gf-zip]").forEach(function (input) {
      var value = String(input.value || "").trim();
      if (value) fromField = value;
    });
    return fromField;
  }

  function selectedPlaceValue() {
    var fromField = "";
    qsa("[data-gf-place]").forEach(function (select) {
      if (select.value) fromField = select.value;
    });
    return fromField;
  }

  function zipPrefixes() {
    return String(settings().zipPrefixes || "")
      .split(/[\s,;]+/)
      .map(function (item) { return item.replace(/\D/g, ""); })
      .filter(function (item) { return item.length === 5; });
  }

  function parseDeliveryArea(raw) {
    var map = {};
    String(raw || "").split(/\n+/).forEach(function (line) {
      line = String(line).replace(/#.*$/, "").trim();
      if (!line) return;
      var splitAt = line.search(/[:|=]/);
      if (splitAt < 0) return;
      var zip = line.slice(0, splitAt).replace(/\D/g, "");
      if (zip.length !== 5) return;
      var places = line.slice(splitAt + 1).split(/[,|;]/).map(function (item) {
        return item.replace(/\s+/g, " ").trim();
      }).filter(Boolean);
      if (places.length) map[zip] = places;
    });
    return map;
  }

  function deliveryArea() {
    var parsed = parseDeliveryArea(settings().deliveryArea);
    if (!Object.keys(parsed).length) parsed = DEFAULT_DELIVERY_AREA;
    zipPrefixes().forEach(function (zip) {
      if (!parsed[zip]) parsed[zip] = [pickupCity()];
    });
    return parsed;
  }

  function placesForZip(zip) {
    return deliveryArea()[String(zip || "")] || [];
  }

  function validateZip(zip, selectedPlace) {
    var raw = String(zip == null ? "" : zip).trim();
    if (!/^\d{5}$/.test(raw)) {
      return {
        ok: false,
        code: "format",
        message: "Bitte gib eine gültige fünfstellige PLZ ein."
      };
    }
    var places = placesForZip(raw);
    if (!places.length) {
      return {
        ok: false,
        code: "outside",
        pickupCta: true,
        message: "Diese PLZ liegt leider außerhalb unseres Liefergebiets. Du kannst deine Bestellung aber zur Abholung in Kitzingen aufgeben."
      };
    }
    if (places.length === 1) {
      return {
        ok: true,
        zip: raw,
        place: places[0],
        places: places,
        message: "Lieferung nach " + raw + " " + places[0] + " ist möglich."
      };
    }
    if (!selectedPlace || places.indexOf(selectedPlace) === -1) {
      return {
        ok: false,
        code: "place",
        zip: raw,
        places: places,
        message: "Bitte wähle deinen Ort aus."
      };
    }
    return {
      ok: true,
      zip: raw,
      place: selectedPlace,
      places: places,
      message: "Lieferung nach " + raw + " " + selectedPlace + " ist möglich."
    };
  }

  function isDeliveryConfirmed() {
    if (currentMode() !== "delivery") return false;
    var storedZip = currentZip();
    var storedPlace = currentPlace();
    var typed = zipInputValue();
    if (typed && typed !== storedZip) return false;
    var result = validateZip(storedZip, storedPlace);
    return !!(result.ok && result.zip && result.place);
  }

  function rememberMode(mode, zip, place) {
    try { localStorage.setItem(MODE_KEY, mode); } catch (error) {}
    if (mode === "delivery" && zip && place) {
      storedSet(ZIP_KEY, zip);
      storedSet(PLACE_KEY, place);
    } else {
      storedSet(ZIP_KEY, "");
      storedSet(PLACE_KEY, "");
    }
  }

  function applyAttributeState(state) {
    window.gfOrder = window.gfOrder || {};
    window.gfOrder.attributes = (state && state.attributes) || {};
    return state;
  }

  function markModeChosen() {
    try { localStorage.setItem(MODE_CHOSEN_KEY, "1"); } catch (error) {}
  }

  function modeWasChosen() {
    try { return localStorage.getItem(MODE_CHOSEN_KEY) === "1"; } catch (error) { return false; }
  }

  function mergeAttributes(existing, mode, zip, place) {
    var attributes = {};
    Object.keys(existing || {}).forEach(function (key) {
      attributes[key] = existing[key];
    });
    attributes[ATTR_MODE] = mode === "pickup" ? "Abholung" : "Lieferung";
    if (mode === "delivery" && zip && place && !isPlaceholderZip(zip)) {
      attributes[ATTR_ZIP] = String(zip);
      attributes[ATTR_PLACE] = String(place);
    } else {
      attributes[ATTR_ZIP] = "";
      attributes[ATTR_PLACE] = "";
    }
    return attributes;
  }

  function syncAttributeFields(mode, zip, place) {
    var modeValue = mode === "pickup" ? "Abholung" : "Lieferung";
    var zipValue = mode === "delivery" && zip && place && !isPlaceholderZip(zip) ? String(zip) : "";
    var placeValue = zipValue ? String(place || "") : "";
    qsa("[data-gf-attr-mode]").forEach(function (input) { input.value = modeValue; });
    qsa("[data-gf-attr-zip]").forEach(function (input) { input.value = zipValue; });
    qsa("[data-gf-attr-place]").forEach(function (input) { input.value = placeValue; });
    qsa("[data-gf-checkout-form], form[action*='/cart']").forEach(applyCheckoutPrefill);
  }

  function setNamedInput(form, name, value, marker) {
    if (!form) return;
    var input = form.querySelector('input[name="' + name.replace(/"/g, "") + '"]');
    if (value == null || value === "") {
      if (input && (input.hasAttribute(marker) || input.getAttribute("data-gf-prefill-zip") != null || input.getAttribute("data-gf-prefill-city") != null)) {
        input.value = "";
      } else if (input && input.hasAttribute("data-gf-prefill")) {
        input.parentNode.removeChild(input);
      }
      return;
    }
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-gf-prefill", "true");
      if (marker) input.setAttribute(marker, "");
      form.appendChild(input);
    }
    input.value = String(value);
  }

  function applyCheckoutPrefill(form) {
    var confirmed = currentMode() === "delivery" && isDeliveryConfirmed();
    var zip = confirmed ? currentZip() : "";
    var city = confirmed ? currentPlace() : "";
    var forms = qsa("[data-gf-checkout-form], form[action*='/cart']");
    if (form && forms.indexOf(form) < 0) forms.push(form);
    forms.forEach(function (node) {
      setNamedInput(node, "checkout[shipping_address][zip]", zip, "data-gf-prefill-zip");
      setNamedInput(node, "checkout[shipping_address][city]", city, "data-gf-prefill-city");
    });
  }

  function leftoverDelivery(state, mode) {
    if (mode !== "pickup") return false;
    var attrs = (state && state.attributes) || {};
    return !!(attrs[ATTR_ZIP] || attrs[ATTR_PLACE]);
  }

  function persistMode(mode, zip, place) {
    cartPending += 1;
    return getCart().then(function (cart) {
      var attributes = mergeAttributes((cart && cart.attributes) || {}, mode, zip, place);
      var savedZip = attributes[ATTR_ZIP] || "";
      var savedPlace = attributes[ATTR_PLACE] || "";
      return fetchJSON(routes().cartUpdateJs, { attributes: attributes }).then(function (state) {
        if (leftoverDelivery(state, mode)) {
          var params = new URLSearchParams();
          Object.keys(attributes).forEach(function (key) {
            var value = attributes[key];
            if (key === ATTR_ZIP || key === ATTR_PLACE) value = "";
            params.append("attributes[" + key + "]", String(value == null ? "" : value));
          });
          return fetchForm(routes().cartUpdateJs, params).then(function (retryState) {
            if (leftoverDelivery(retryState, mode)) {
              showToast("Gespeicherte Lieferdaten konnten nicht vollständig entfernt werden. Die Adresse prüft der Checkout.");
            }
            rememberMode(mode, "", "");
            syncAttributeFields(mode, "", "");
            markModeChosen();
            return applyAttributeState(retryState);
          });
        }
        rememberMode(mode, savedZip, savedPlace);
        syncAttributeFields(mode, savedZip, savedPlace);
        markModeChosen();
        return applyAttributeState(state);
      });
    }).then(function (state) {
      cartPending = Math.max(0, cartPending - 1);
      return state;
    }, function (error) {
      cartPending = Math.max(0, cartPending - 1);
      throw error;
    });
  }

  function currentNote() {
    var note = "";
    qsa("[data-cart-note]").forEach(function (field) {
      if (field.value) note = field.value;
    });
    return note.slice(0, 500);
  }

  function persistNote(note) {
    return fetchJSON(routes().cartUpdateJs, { note: note == null ? "" : String(note).slice(0, 500) });
  }

  function waitForCartIdle() {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        if (cartPending <= 0 || tries++ > 50) resolve();
        else window.setTimeout(check, 60);
      })();
    });
  }

  function persistCheckoutState() {
    var mode = currentMode();
    var zip = "";
    var place = "";
    if (mode === "delivery") {
      if (!isDeliveryConfirmed()) {
        return Promise.reject(new Error("Bitte prüfe zuerst PLZ und Lieferort, bevor du zur Kasse gehst."));
      }
      zip = currentZip();
      place = currentPlace();
    }
    var note = currentNote();
    var work = waitForCartIdle().then(function () {
      return getCart();
    }).then(function (cart) {
      var attributes = mergeAttributes((cart && cart.attributes) || {}, mode, zip, place);
      return fetchJSON(routes().cartUpdateJs, {
        note: note,
        attributes: attributes
      }).then(function (state) {
        if (mode === "pickup" && leftoverDelivery(state, mode)) {
          var params = new URLSearchParams();
          Object.keys(attributes).forEach(function (key) {
            var value = attributes[key];
            if (key === ATTR_ZIP || key === ATTR_PLACE) value = "";
            params.append("attributes[" + key + "]", String(value == null ? "" : value));
          });
          params.append("note", note);
          return fetchForm(routes().cartUpdateJs, params).then(function (retryState) {
            rememberMode(mode, "", "");
            syncAttributeFields(mode, "", "");
            return applyAttributeState(retryState);
          });
        }
        rememberMode(mode, attributes[ATTR_ZIP] || "", attributes[ATTR_PLACE] || "");
        syncAttributeFields(mode, attributes[ATTR_ZIP] || "", attributes[ATTR_PLACE] || "");
        applyCheckoutPrefill();
        return applyAttributeState(state);
      });
    });
    return Promise.race([
      work,
      new Promise(function (resolve, reject) {
        window.setTimeout(function () {
          reject(new Error("Die Warenkorb-Übergabe hat zu lange gedauert."));
        }, 5000);
      })
    ]);
  }

  function shippingCheckoutQuery() {
    var parts = [];
    function add(name, value) {
      parts.push(name + "=" + encodeURIComponent(String(value)));
    }
    if (currentMode() === "delivery" && isDeliveryConfirmed()) {
      add("checkout[shipping_address][zip]", currentZip());
      add("checkout[shipping_address][city]", currentPlace());
      var country = settings().country || "Germany";
      if (/^DE$/i.test(country) || /deutschland/i.test(country)) country = "Germany";
      add("checkout[shipping_address][country]", country);
    }
    add("skip_shop_pay", "true");
    return parts.join("&");
  }

  function pickupHandles() {
    return ((settings().pickupHandles) || []).filter(function (id) { return !!id; });
  }

  function storefrontCartId(cart) {
    var token = cart && cart.token;
    if (!token) return "";
    if (String(token).indexOf("gid://") === 0) return token;
    return "gid://shopify/Cart/" + token;
  }

  function storefrontToken() {
    var shopify = window.Shopify || {};
    return shopify.storefrontAccessToken || shopify.StorefrontAccessToken || settings().storefrontToken || "";
  }

  function storefrontGraphql(query, variables) {
    var headers = { "Content-Type": "application/json", "Accept": "application/json" };
    var token = storefrontToken();
    if (token) headers["X-Shopify-Storefront-Access-Token"] = token;
    return fetch("/api/2025-07/graphql.json", {
      method: "POST",
      credentials: "same-origin",
      headers: headers,
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (res) {
      if (!res.ok) throw new Error("storefront " + res.status);
      return res.json();
    });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(null);
      }, ms);
      promise.then(function (value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }, function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(null);
      });
    });
  }

  function applyCheckoutDeliveryPreference(mode) {
    return getCart().then(function (cart) {
      var cartId = storefrontCartId(cart);
      if (!cartId) return null;
      var delivery = mode === "pickup"
        ? { deliveryMethod: ["PICK_UP"] }
        : { deliveryMethod: ["SHIPPING"] };
      var handles = pickupHandles();
      if (mode === "pickup" && handles.length) delivery.pickupHandle = handles;
      var mutation = "mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { id buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } } } userErrors { field message } } }";
      return withTimeout(storefrontGraphql(mutation, {
        cartId: cartId,
        buyerIdentity: {
          countryCode: "DE",
          preferences: { delivery: delivery }
        }
      }), 1600);
    }).catch(function () {
      return null;
    });
  }

  function syncAllAttributeInputs(form, attributes) {
    if (!form || !attributes) return;
    Object.keys(attributes).forEach(function (key) {
      var value = attributes[key];
      setNamedInput(form, "attributes[" + key + "]", value == null ? "" : String(value), "data-gf-attr-dyn");
    });
  }

  function goToExistingCartCheckout(form, state) {
    applyCheckoutPrefill(form);
    syncAllAttributeInputs(form, state && state.attributes);
    checkoutHandoff = true;
    window.location.assign("/checkout?" + shippingCheckoutQuery());
  }

  function submitNativeCartForm(form, state) {
    goToExistingCartCheckout(form, state);
  }

  function beginNativeCheckout(form, button) {
    if (checkoutHandoff) return Promise.resolve();
    if (button && button.getAttribute("aria-busy") === "true") return Promise.resolve();
    if (currentMode() === "delivery" && !isDeliveryConfirmed()) {
      blockUnconfirmedDelivery();
      return Promise.resolve();
    }
    setCheckoutBusy(button, true);
    showCheckoutError("");
    return persistCheckoutState()
      .then(function (state) {
        return applyCheckoutDeliveryPreference(currentMode()).then(function () { return state; });
      })
      .then(function (state) {
        submitNativeCartForm(form, state);
      })
      .catch(function (error) {
        checkoutHandoff = false;
        setCheckoutBusy(button, false);
        if (currentMode() === "delivery" && !isDeliveryConfirmed()) {
          blockUnconfirmedDelivery();
          return;
        }
        showCheckoutError(error.message || "Der Checkout konnte nicht gestartet werden. Bitte Verbindung prüfen und erneut versuchen.");
      });
  }

  function setCheckoutBusy(button, busy) {
    qsa("[data-gf-checkout]").forEach(function (node) {
      if (busy) {
        node.setAttribute("aria-busy", "true");
        node.setAttribute("disabled", "disabled");
        node.classList.add("is-loading");
      } else {
        node.removeAttribute("aria-busy");
        node.classList.remove("is-loading");
      }
    });
    if (!busy) {
      var countEl = qs("[data-cart-count]");
      var count = parseInt((countEl && countEl.textContent) || "0", 10) || 0;
      setCheckoutEnabled(count > 0);
    }
  }

  function showCheckoutError(message) {
    qsa("[data-gf-checkout-error]").forEach(function (node) {
      node.hidden = !message;
      node.textContent = message || "";
    });
    if (message) showToast(message);
  }

  function headerPlaceLabel(mode) {
    if (mode === "pickup") return pickupCity();
    if (isDeliveryConfirmed()) return currentPlace();
    return "Ort wählen";
  }

  function setModeUI(mode) {
    qsa("button[data-gf-mode]").forEach(function (button) {
      var active = button.getAttribute("data-gf-mode") === mode;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
    qsa("[data-gf-panel]").forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-gf-panel") !== mode;
    });
    qsa("[data-gf-mode-label]").forEach(function (node) {
      node.textContent = mode === "pickup" ? "Abholung" : "Lieferung";
    });
    qsa("[data-gf-mode-place]").forEach(function (node) {
      node.textContent = headerPlaceLabel(mode);
    });
    document.body.setAttribute("data-gf-current-mode", mode);
    if (mode === "pickup") {
      qsa("[data-gf-zip]").forEach(function (input) { input.value = ""; });
      hidePlaceSelects();
      clearZipMessages();
    } else {
      var zip = currentZip();
      if (!isPlaceholderZip(zip)) {
        qsa("[data-gf-zip]").forEach(function (input) {
          if (!input.value || isPlaceholderZip(input.value)) input.value = zip;
        });
        var result = validateZip(zip, currentPlace());
        syncPlaceSelects(result.places || placesForZip(zip), result.ok ? result.place : currentPlace());
        if (result.ok) renderZipMessage(null, result);
      }
    }
    syncAttributeFields(mode, mode === "delivery" && isDeliveryConfirmed() ? currentZip() : "", mode === "delivery" && isDeliveryConfirmed() ? currentPlace() : "");
  }

  function openFulfillment() {
    var panel = qs("[data-gf-fulfillment]");
    var overlay = qs("[data-gf-fulfillment-overlay]");
    if (!panel) return;
    panel.classList.add("is-open");
    panel.setAttribute("aria-modal", "true");
    if (overlay) overlay.classList.add("is-open");
    qsa("[data-gf-open-fulfillment]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "true");
    });
  }

  function focusZipArea() {
    var bar = qs(".gf-fulfillment-bar") || qs("[data-gf-zip-form]");
    var input = qs(".gf-fulfillment-bar [data-gf-zip]") || qs("[data-gf-zip]");
    if (bar && bar.scrollIntoView) {
      bar.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center" });
    } else {
      openFulfillment();
    }
    if (input && input.focus) {
      input.setAttribute("aria-invalid", "true");
      window.setTimeout(function () { input.focus(); }, 50);
    }
  }

  function blockUnconfirmedDelivery() {
    var result = validateZip(zipInputValue(), selectedPlaceValue());
    var text = result.message || "Bitte prüfe zuerst PLZ und Lieferort, bevor du zur Kasse gehst.";
    if (!zipInputValue()) {
      text = "Bitte gib eine gültige fünfstellige PLZ ein.";
    } else if (result.code === "place") {
      text = "Bitte wähle deinen Ort aus, bevor du zur Kasse gehst.";
    } else if (result.ok) {
      text = "Bitte prüfe zuerst PLZ und Lieferort, bevor du zur Kasse gehst.";
    }
    renderZipMessage(null, { ok: false, code: result.code, pickupCta: result.pickupCta, message: text });
    showCheckoutError(text);
    focusZipArea();
  }

  function hidePlaceSelects() {
    qsa("[data-gf-place-wrap]").forEach(function (wrap) { wrap.hidden = true; });
    qsa("[data-gf-place]").forEach(function (select) {
      select.innerHTML = "";
      select.value = "";
      select.removeAttribute("required");
    });
  }

  function syncPlaceSelects(places, selected) {
    places = places || [];
    if (places.length < 2) {
      hidePlaceSelects();
      return;
    }
    qsa("[data-gf-place-wrap]").forEach(function (wrap) { wrap.hidden = false; });
    qsa("[data-gf-place]").forEach(function (select) {
      var current = selected || select.value || "";
      select.innerHTML = "";
      var blank = document.createElement("option");
      blank.value = "";
      blank.textContent = "Bitte Ort wählen";
      select.appendChild(blank);
      places.forEach(function (place) {
        var option = document.createElement("option");
        option.value = place;
        option.textContent = place;
        if (place === current) option.selected = true;
        select.appendChild(option);
      });
      select.setAttribute("required", "required");
    });
  }

  function clearZipMessages() {
    qsa("[data-gf-zip-msg]").forEach(function (message) {
      message.hidden = true;
      message.textContent = "";
      message.classList.remove("is-error", "is-ok", "is-info");
      message.removeAttribute("role");
    });
    qsa("[data-gf-zip]").forEach(function (input) {
      input.removeAttribute("aria-invalid");
    });
  }

  function renderZipMessage(_ignored, result) {
    qsa("[data-gf-zip-msg]").forEach(function (message) {
      message.hidden = false;
      message.classList.toggle("is-error", !result.ok);
      message.classList.toggle("is-ok", !!result.ok);
      message.classList.toggle("is-info", !!result.ok);
      message.setAttribute("role", result.ok ? "status" : "alert");
      message.setAttribute("aria-live", "polite");
      message.textContent = "";
      var text = document.createElement("span");
      text.textContent = result.message || "";
      message.appendChild(text);
      if (result.pickupCta) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "gf-zip-pickup";
        button.setAttribute("data-gf-choose-pickup", "");
        button.textContent = "Abholung wählen";
        message.appendChild(button);
      }
    });
    qsa("[data-gf-zip]").forEach(function (input) {
      if (result.ok) input.removeAttribute("aria-invalid");
      else input.setAttribute("aria-invalid", "true");
    });
  }

  function applyZipResult(result, persist) {
    syncPlaceSelects(result.places || [], result.place || selectedPlaceValue());
    renderZipMessage(null, result);
    if (!persist || !result.ok) return Promise.resolve();
    return persistMode("delivery", result.zip, result.place).then(function () {
      qsa("[data-gf-zip]").forEach(function (field) { field.value = result.zip; });
      setModeUI("delivery");
      closeFulfillment();
      renderZipMessage(null, result);
    });
  }

  function showToast(message) {
    var toast = qs("[data-gf-toast]");
    if (!toast || !message) return;
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () { toast.hidden = true; }, 2800);
  }

  function refreshOrderBar(count) {
    var bar = qs("[data-gf-orderbar]");
    var countEl = qs("[data-cart-count]");
    var value = typeof count === "number" ? count : parseInt((countEl && countEl.textContent) || "0", 10) || 0;
    if (bar) bar.classList.toggle("is-visible", value > 0);
    document.body.classList.toggle("gf-orderbar-on", value > 0);
    updateMinOrder();
  }

  function minOrderCents() {
    return Number(settings().minOrderCents || 0) || 0;
  }

  function parsePrice(text) {
    if (!text) return 0;
    var clean = String(text).replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
    return Math.round(parseFloat(clean) * 100) || 0;
  }

  function updateMinOrder() {
    var min = minOrderCents();
    var nodes = qsa("[data-gf-min-order]");
    if (!nodes.length) return;
    var priceEl = qs("[data-cart-price]");
    var total = parsePrice(priceEl && priceEl.textContent);
    nodes.forEach(function (node) {
      if (!min) {
        node.hidden = true;
        return;
      }
      node.hidden = false;
      if (total >= min) {
        node.textContent = "Der optional hinterlegte Hinweiswert ist erreicht. Versandregeln prüft der Checkout.";
        node.classList.remove("is-short");
      } else {
        node.textContent = "Noch " + formatMoney(min - total) + " bis zum optional hinterlegten Hinweiswert. Versandregeln prüft der Checkout.";
        node.classList.add("is-short");
      }
    });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function extrasHtml(item) {
    var parts = [];
    if (item.variant_title && item.variant_title !== "Default Title") {
      parts.push('<p class="gf-rail-item__meta">' + escapeHtml(item.variant_title) + "</p>");
    }
    var props = item.properties || {};
    Object.keys(props).forEach(function (name) {
      if (!name || name.charAt(0) === "_") return;
      if (props[name] == null || props[name] === "") return;
      parts.push('<p class="gf-rail-item__meta">' + escapeHtml(name) + ": " + escapeHtml(props[name]) + "</p>");
    });
    return parts.join("");
  }

  function renderRail(state) {
    var rail = qs("[data-gf-cart-rail]");
    if (!rail || !state) return;
    var empty = !state.item_count;
    rail.classList.toggle("is-empty", empty);
    var emptyNode = qs("[data-gf-rail-empty]", rail);
    var footer = qs("[data-gf-rail-footer]", rail);
    var checkout = qs("[data-gf-rail-checkout]", rail);
    var list = qs("[data-gf-rail-items]", rail);
    if (emptyNode) emptyNode.hidden = !empty;
    if (footer) footer.hidden = empty;
    setCheckoutEnabled(!empty);
    if (!list) return;
    if (empty) {
      list.innerHTML = "";
      return;
    }
    list.innerHTML = state.items.map(function (item) {
      var img = item.image
        ? '<img class="gf-rail-item__img" src="' + escapeHtml(item.image) + '" width="64" height="64" alt="">'
        : '<div class="gf-media-fallback gf-media-fallback--thumb" aria-hidden="true"></div>';
      return (
        '<li class="gf-rail-item" data-gf-line="' + escapeHtml(item.key) + '">' +
          img +
          '<div class="gf-rail-item__info">' +
            '<p class="gf-rail-item__name">' + escapeHtml(item.product_title || item.title) + "</p>" +
            extrasHtml(item) +
          "</div>" +
          '<div class="gf-qty">' +
            '<button type="button" data-gf-line-qty="minus" data-gf-line="' + escapeHtml(item.key) + '" aria-label="Menge verringern">−</button>' +
            '<span data-gf-line-qty-value>' + item.quantity + "</span>" +
            '<button type="button" data-gf-line-qty="plus" data-gf-line="' + escapeHtml(item.key) + '" aria-label="Menge erhöhen">+</button>' +
          "</div>" +
          '<span class="gf-rail-item__price">' + formatMoney(item.final_line_price) + "</span>" +
          '<button type="button" class="gf-rail-item__remove" data-gf-line-remove data-gf-line="' + escapeHtml(item.key) + '">Entfernen</button>' +
        "</li>"
      );
    }).join("");
  }

  function syncExpressCart(state) {
    var hasItems = !!(state && state.item_count > 0);
    if (!window.carts || !window.carts.length) {
      setCheckoutEnabled(hasItems);
      return;
    }
    window.carts.forEach(function (cart) {
      try {
        if (typeof cart.renderCart === "function") cart.renderCart(state);
        if (!hasItems) {
          if (typeof cart.renderEmptyCart === "function") cart.renderEmptyCart();
          return;
        }
        var items = typeof cart.renderCartItems === "function" ? cart.renderCartItems(state) : null;
        Promise.resolve(items).then(function () {
          setCheckoutEnabled(true);
        }).catch(function () {
          setCheckoutEnabled(true);
        });
      } catch (error) {
        setCheckoutEnabled(hasItems);
      }
    });
    setCheckoutEnabled(hasItems);
  }

  function applyCartState(state) {
    if (!state) return;
    var count = state.item_count || 0;
    renderRail(state);
    refreshOrderBar(count);
    qsa("[data-cart-count]").forEach(function (node) {
      node.textContent = count > 99 ? "99+" : String(count);
    });
    qsa("[data-cart-count-bubble]").forEach(function (node) {
      node.classList.toggle("hidden", count === 0);
    });
    qsa("[data-cart-price]").forEach(function (node) {
      node.innerHTML = formatMoney(state.total_price);
    });
    var countsByProduct = {};
    (state.items || []).forEach(function (item) {
      countsByProduct[item.product_id] = (countsByProduct[item.product_id] || 0) + item.quantity;
    });
    qsa("[data-gf-dish]").forEach(function (dish) {
      var id = dish.getAttribute("data-product-id");
      var qty = countsByProduct[id] || countsByProduct[Number(id)] || 0;
      var badge = qs("[data-gf-dish-qty]", dish);
      if (badge) {
        var label = qs("[data-gf-dish-qty-label]", badge);
        badge.hidden = qty === 0;
        if (label) {
          label.textContent = qty > 0 ? "Im Warenkorb · " + qty : "Im Warenkorb";
        } else {
          badge.textContent = qty > 0 ? "Im Warenkorb · " + qty : "";
        }
        if (qty > 0) badge.setAttribute("aria-label", qty + " im Warenkorb");
        else badge.removeAttribute("aria-label");
      }
    });
    var checkout = qs("[data-gf-rail-checkout]");
    if (checkout) {
      if (count) checkout.removeAttribute("disabled");
      else checkout.setAttribute("disabled", "disabled");
    }
    setCheckoutEnabled(count > 0);
    qsa("[data-cart-note]").forEach(function (field) {
      if (document.activeElement === field) return;
      if (typeof state.note === "string" && field.value !== state.note) {
        field.value = state.note;
      }
    });
    var attrs = (state && state.attributes) || {};
    var mode = attrs[ATTR_MODE] === "Abholung" ? "pickup" : (attrs[ATTR_MODE] === "Lieferung" ? "delivery" : currentMode());
    syncAttributeFields(mode, attrs[ATTR_ZIP] || "", attrs[ATTR_PLACE] || "");
    setCheckoutEnabled(count > 0);
    stripInjectedCheckoutWidgets();
  }

  function setCheckoutEnabled(enabled) {
    qsa("[data-gf-checkout], [data-checkout-button]").forEach(function (button) {
      if (enabled && button.getAttribute("aria-busy") === "true") return;
      if (enabled) {
        button.removeAttribute("disabled");
        button.disabled = false;
      } else {
        button.setAttribute("disabled", "disabled");
        button.disabled = true;
      }
    });
    qsa("[data-cart]").forEach(function (drawer) {
      drawer.classList.toggle("is-empty", !enabled);
    });
    qsa("[data-gf-cart-rail]").forEach(function (rail) {
      rail.classList.toggle("is-empty", !enabled);
    });
  }

  function changeLine(key, quantity) {
    var seq = ++cartSeq;
    lineSeq[key] = seq;
    cartPending += 1;
    qsa('[data-gf-line="' + key + '"]').forEach(function (node) {
      node.setAttribute("aria-busy", "true");
    });
    return fetchJSON(routes().cartChangeJs, { id: key, quantity: quantity }).then(function (state) {
      if (lineSeq[key] !== seq) return state;
      applyCartState(state);
      syncExpressCart(state);
      return state;
    }).catch(function (error) {
      if (lineSeq[key] !== seq) return;
      showToast(error.message || "Die Menge konnte nicht geändert werden. Bitte erneut versuchen.");
      return getCart().then(function (state) {
        applyCartState(state);
        syncExpressCart(state);
        return state;
      });
    }).then(function (state) {
      if (lineSeq[key] === seq) {
        qsa('[data-gf-line="' + key + '"]').forEach(function (node) {
          node.removeAttribute("aria-busy");
        });
      }
      cartPending = Math.max(0, cartPending - 1);
      return state;
    });
  }

  function quantityForLine(key) {
    var node = qs('li[data-gf-line="' + key + '"] [data-gf-line-qty-value]');
    return parseInt((node && node.textContent) || "1", 10) || 1;
  }

  function filterMenu(query) {
    var menu = qs("[data-gf-menu]");
    if (!menu) return;
    var needle = (query || "").trim().toLowerCase();
    var visible = 0;
    qsa("[data-gf-group]", menu).forEach(function (group) {
      var groupVisible = 0;
      qsa("[data-gf-dish]", group).forEach(function (dish) {
        var haystack = dish.getAttribute("data-gf-search") || "";
        var match = !needle || haystack.indexOf(needle) !== -1;
        dish.classList.toggle("is-filtered-out", !match);
        if (match) groupVisible += 1;
      });
      group.hidden = groupVisible === 0;
      visible += groupVisible;
    });
    menu.classList.toggle("is-empty", visible === 0);
    var empty = qs("[data-gf-empty]", menu);
    if (empty) empty.hidden = visible !== 0;
    var clear = qs("[data-gf-search-clear]");
    if (clear) clear.hidden = !needle;
  }

  var tabScrollLock = null;
  var tabScrollTimer = 0;

  function setActiveTab(id) {
    if (!id) return;
    var current = qs("[data-gf-tab][aria-current='true']");
    var currentHash = "";
    if (current) {
      currentHash = current.getAttribute("data-gf-target") || "";
      if (!currentHash) {
        var href = current.getAttribute("href") || "";
        currentHash = href.indexOf("#") >= 0 ? href.slice(href.indexOf("#") + 1) : "";
      }
    }
    var already = currentHash === id;
    qsa("[data-gf-tab]").forEach(function (tab) {
      var targetId = tab.getAttribute("data-gf-target") || "";
      if (!targetId) {
        var href = tab.getAttribute("href") || "";
        targetId = href.indexOf("#") >= 0 ? href.slice(href.indexOf("#") + 1) : "";
      }
      var match = targetId === id;
      tab.classList.toggle("is-active", match);
      tab.setAttribute("aria-selected", match ? "true" : "false");
      tab.tabIndex = match ? 0 : -1;
      if (match) tab.setAttribute("aria-current", "true");
      else tab.removeAttribute("aria-current");
    });
    if (already) return;
    var active = qs('[data-gf-tab][data-gf-target="' + id + '"], [data-gf-tab][href="#' + id + '"], [data-gf-tab][href$="#' + id + '"]');
    alignChipInScroller(active);
  }

  function alignChipInScroller(tab) {
    var scroller = qs(".gf-menu__scroller");
    if (!scroller || !tab || !scroller.contains(tab)) return;
    var scrollerBox = scroller.getBoundingClientRect();
    var tabBox = tab.getBoundingClientRect();
    var pad = 16;
    if (tabBox.left < scrollerBox.left + pad) {
      scroller.scrollLeft += tabBox.left - scrollerBox.left - pad;
    } else if (tabBox.right > scrollerBox.right - pad) {
      scroller.scrollLeft += tabBox.right - scrollerBox.right + pad;
    }
  }

  function stickyOffset() {
    var headerH = (qs(".header-wrapper") || {}).offsetHeight || 0;
    var nav = qs(".gf-menu__nav");
    var navH = nav ? nav.offsetHeight : 0;
    return headerH + navH + 8;
  }

  function scrollToGroup(id, updateHash) {
    var target = document.getElementById(id);
    if (!target) return;
    tabScrollLock = id;
    window.clearTimeout(tabScrollTimer);
    setActiveTab(id);
    var pos = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - stickyOffset());
    var root = document.documentElement;
    var previous = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    if (root.scrollTo) root.scrollTo(0, pos);
    window.scrollTo(0, pos);
    document.body.scrollTop = pos;
    root.style.scrollBehavior = previous;
    if (updateHash && history.replaceState) {
      history.replaceState(null, "", location.pathname + location.search + "#" + id);
    }
    tabScrollTimer = window.setTimeout(function () {
      tabScrollLock = null;
    }, prefersReducedMotion() ? 80 : 450);
  }

  function updateActiveTabFromScroll() {
    if (tabScrollLock) return;
    var groups = qsa("[data-gf-group]");
    if (!groups.length) return;
    var offset = stickyOffset();
    var current = groups[0];
    groups.forEach(function (group) {
      if (group.getBoundingClientRect().top - offset <= 16) current = group;
    });
    if (current) setActiveTab(current.id);
  }

  function addVariant(variantId, button) {
    if (!variantId) {
      showToast("Dieses Gericht kann gerade nicht hinzugefügt werden.");
      return;
    }
    if (button && button.getAttribute("aria-busy") === "true") return;
    var seq = ++cartSeq;
    cartPending += 1;
    if (button) button.setAttribute("aria-busy", "true");
    return fetchJSON(routes().cartAddJs, { id: Number(variantId), quantity: 1 })
      .catch(function (error) {
        if (error && error.status === 422) throw error;
        var params = new URLSearchParams();
        params.set("id", String(variantId));
        params.set("quantity", "1");
        return fetchForm(routes().cartAddJs, params);
      })
      .then(function () { return getCart(); })
      .then(function (state) {
        if (seq !== cartSeq) return state;
        applyCartState(state);
        syncExpressCart(state);
        showToast("Hinzugefügt");
        return state;
      })
      .catch(function (error) {
        if (seq !== cartSeq) return;
        showToast(error.message || "Das Gericht konnte nicht hinzugefügt werden. Bitte Verbindung prüfen und erneut versuchen.");
      })
      .then(function () {
        if (button) button.removeAttribute("aria-busy");
        cartPending = Math.max(0, cartPending - 1);
      });
  }

  function optionDialog() {
    return qs("[data-gf-option-dialog]");
  }

  function closeOptionDialog() {
    var dialog = optionDialog();
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove("gf-option-open");
    var opener = closeOptionDialog.opener;
    closeOptionDialog.opener = null;
    if (opener && opener.focus) opener.focus();
  }

  function openOptionDialog(button) {
    var script = button.parentNode && qs("[data-gf-variants]", button.parentNode);
    if (!script) {
      showToast("Die Auswahl für dieses Gericht fehlt.");
      return;
    }
    var data;
    try { data = JSON.parse(script.textContent); } catch (error) {
      showToast("Die Auswahl für dieses Gericht konnte nicht gelesen werden.");
      return;
    }
    var dialog = optionDialog();
    var fields = dialog && qs("[data-gf-option-fields]", dialog);
    var title = dialog && qs("[data-gf-option-title]", dialog);
    var error = dialog && qs("[data-gf-option-error]", dialog);
    var copy = dialog && qs("[data-gf-option-copy]", dialog);
    var media = dialog && qs("[data-gf-option-media]", dialog);
    if (!dialog || !fields) return;
    closeOptionDialog.opener = button;
    if (title) title.textContent = data.title || "Optionen wählen";
    if (copy) {
      copy.textContent = data.description || "";
      copy.hidden = !data.description;
    }
    if (media) {
      if (data.image) {
        media.innerHTML = '<img src="' + escapeHtml(data.image) + '" alt="" width="88" height="88">';
        media.hidden = false;
      } else {
        media.innerHTML = "";
        media.hidden = true;
      }
    }
    if (error) {
      error.hidden = true;
      error.textContent = "";
    }
    fields.innerHTML = (data.variants || []).map(function (variant) {
      if (!variant.available) {
        return '<p class="gf-option-dialog__soldout">' + escapeHtml(variant.title) + " · ausverkauft</p>";
      }
      return (
        '<button type="button" class="gf-option-dialog__choice" data-gf-option-variant="' + variant.id + '">' +
          "<span>" + escapeHtml(variant.title) + "</span>" +
          "<strong>Für " + formatMoney(variant.price) + " hinzufügen</strong>" +
        "</button>"
      );
    }).join("");
    dialog.hidden = false;
    document.body.classList.add("gf-option-open");
    var panel = qs(".gf-option-dialog__panel", dialog);
    if (panel) panel.focus();
  }

  function enableDesktopRail() {
    var rail = qs("[data-gf-cart-rail]");
    if (!rail) return;
    var desktop = window.matchMedia("(min-width: 1100px)").matches;
    document.body.classList.toggle("gf-desktop-rail", desktop);
  }

  function closeFulfillment() {
    var panel = qs("[data-gf-fulfillment]");
    var overlay = qs("[data-gf-fulfillment-overlay]");
    var wasPrompt = panel && panel.classList.contains("gf-fulfillment--prompt");
    if (panel) {
      panel.classList.remove("is-open", "gf-fulfillment--prompt");
      panel.setAttribute("aria-modal", "false");
      panel.removeAttribute("aria-hidden");
      panel.removeAttribute("inert");
    }
    if (overlay) overlay.classList.remove("is-open");
    document.documentElement.classList.remove("gf-fulfillment-prompt");
    document.documentElement.style.removeProperty("overflow");
    if (document.body) {
      document.body.classList.remove("gf-fulfillment-prompt");
      document.body.style.removeProperty("overflow");
    }
    qsa("[data-gf-open-fulfillment]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
      if (!wasPrompt && document.activeElement && panel && panel.contains(document.activeElement) && btn.focus) {
        try { btn.focus({ preventScroll: true }); } catch (error) { btn.focus(); }
      }
    });
    return wasPrompt;
  }

  function isFulfillmentPromptOpen() {
    var panel = qs("[data-gf-fulfillment]");
    return !!(panel && panel.classList.contains("is-open") && panel.classList.contains("gf-fulfillment--prompt"));
  }

  function scrollAndFocusZip() {
    var bar = qs(".gf-fulfillment-bar") || qs("[data-gf-zip-form]");
    var input = qs(".gf-fulfillment-bar [data-gf-zip]") || qs("[data-gf-zip]");
    if (bar && bar.scrollIntoView) {
      bar.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center" });
    }
    if (input && input.focus) {
      window.setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
      }, 80);
    }
  }

  function completeFulfillmentChoice(mode) {
    if (mode !== "pickup" && mode !== "delivery") return;
    var fromPrompt = isFulfillmentPromptOpen();
    var keepDelivery = mode === "delivery" && isDeliveryConfirmed();
    var zip = keepDelivery ? currentZip() : "";
    var place = keepDelivery ? currentPlace() : "";
    rememberMode(mode, zip, place);
    markModeChosen();
    applyAttributeState({ attributes: mergeAttributes((config().attributes) || {}, mode, zip, place) });
    syncAttributeFields(mode, zip, place);
    setModeUI(mode);
    closeFulfillment();
    if (fromPrompt && mode === "delivery") scrollAndFocusZip();
    persistMode(mode, zip, place).catch(function () {
      window.setTimeout(function () {
        persistMode(mode, zip, place).catch(function () {});
      }, 1200);
    });
  }

  function bindDelegatedEvents() {
    if (bindDelegatedEvents.bound) return;
    bindDelegatedEvents.bound = true;
    document.documentElement.setAttribute("data-gf-events", "true");
    document.addEventListener("click", function (event) {
      var checkoutBtn = event.target.closest && event.target.closest("[data-gf-checkout]");
      if (!checkoutBtn) return;
      var form = checkoutBtn.closest("[data-gf-checkout-form], form");
      if (!form) return;
      if (checkoutHandoff) return;
      var count = parseInt((qs("[data-cart-count]") || {}).textContent, 10) || 0;
      if (checkoutBtn.disabled && count > 0) {
        checkoutBtn.removeAttribute("disabled");
      }
      if (checkoutBtn.disabled && count <= 0) return;
      event.preventDefault();
      event.stopPropagation();
      beginNativeCheckout(form, checkoutBtn);
    }, true);
    document.addEventListener("click", function (event) {
      var origin = fromEvent(event);
      if (!origin) return;
      try {
      var modeBtn = origin.closest("button[data-gf-mode]");
      if (modeBtn) {
        event.preventDefault();
        completeFulfillmentChoice(modeBtn.getAttribute("data-gf-mode"));
        return;
      }

      var fulfillmentToggle = origin.closest("[data-gf-open-fulfillment]");
      if (fulfillmentToggle) {
        var panel = qs("[data-gf-fulfillment]");
        if (!panel) return;
        if (panel.classList.contains("is-open")) closeFulfillment();
        else {
          panel.classList.add("is-open");
          panel.setAttribute("aria-modal", "true");
          var overlay = qs("[data-gf-fulfillment-overlay]");
          if (overlay) overlay.classList.add("is-open");
          fulfillmentToggle.setAttribute("aria-expanded", "true");
          var focusable = qs("button, input", panel);
          if (focusable) focusable.focus();
        }
        return;
      }

      if (origin.closest("[data-gf-fulfillment-overlay]")) {
        closeFulfillment();
        return;
      }

      var searchClear = origin.closest("[data-gf-search-clear]");
      if (searchClear) {
        var input = qs("[data-gf-search]", searchClear.parentNode) || qs("[data-gf-search]");
        if (input) {
          input.value = "";
          filterMenu("");
          input.focus();
        }
        return;
      }

      var menuLink = origin.closest('a[href="#menu"], a[href$="#menu"]');
      if (menuLink) {
        var menu = document.getElementById("menu");
        if (!menu) return;
        event.preventDefault();
        var header = (qs(".header-wrapper") || {}).offsetHeight || 0;
        var top = menu.getBoundingClientRect().top + window.pageYOffset - header - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? "auto" : "smooth" });
        return;
      }

      var pickupCta = origin.closest("[data-gf-choose-pickup]");
      if (pickupCta) {
        event.preventDefault();
        persistMode("pickup", "", "")
          .then(function () {
            setModeUI("pickup");
            closeFulfillment();
          })
          .catch(function (error) {
            showToast(error.message || "Abholung konnte nicht gespeichert werden.");
          });
        return;
      }

      var chooseBtn = origin.closest("[data-gf-choose]");
      if (chooseBtn) {
        event.preventDefault();
        openOptionDialog(chooseBtn);
        return;
      }

      var optionVariant = origin.closest("[data-gf-option-variant]");
      if (optionVariant) {
        event.preventDefault();
        addVariant(optionVariant.getAttribute("data-gf-option-variant"), optionVariant).then(function () {
          closeOptionDialog();
        });
        return;
      }

      if (origin.closest("[data-gf-option-close]")) {
        event.preventDefault();
        closeOptionDialog();
        return;
      }

      var tab = origin.closest("[data-gf-tab]");
      if (tab) {
        var targetId = tab.getAttribute("data-gf-target") || "";
        if (!targetId) {
          var href = tab.getAttribute("href") || "";
          var hashIndex = href.indexOf("#");
          if (hashIndex >= 0) targetId = href.slice(hashIndex + 1);
        }
        if (!targetId) return;
        event.preventDefault();
        if (tab.focus) tab.focus({ preventScroll: true });
        scrollToGroup(targetId, true);
        return;
      }

      var addBtn = origin.closest("[data-gf-add]");
      if (addBtn) {
        event.preventDefault();
        addVariant(addBtn.getAttribute("data-variant-id"), addBtn);
        return;
      }

      var drawerQty = origin.closest("[data-gf-qty]");
      if (drawerQty) {
        var wrap = drawerQty.closest(".gf-qty") || drawerQty.parentNode;
        var qtyInput = wrap && qs("[data-cart-item-quantity]", wrap);
        if (!qtyInput) return;
        event.preventDefault();
        var current = parseInt(qtyInput.value, 10);
        if (isNaN(current)) current = 1;
        var nextQty = drawerQty.getAttribute("data-gf-qty") === "plus" ? current + 1 : Math.max(0, current - 1);
        qtyInput.value = nextQty;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        scheduleRailSync();
        return;
      }

      if (origin.closest("[data-remove]") && origin.closest("[data-cart]")) {
        scheduleRailSync();
      }

      var lineBtn = origin.closest("[data-gf-line-qty], [data-gf-line-remove]");
      if (lineBtn) {
        event.preventDefault();
        var key = lineBtn.getAttribute("data-gf-line");
        if (!key || lineBtn.getAttribute("aria-busy") === "true") return;
        if (lineBtn.hasAttribute("data-gf-line-remove") || lineBtn.getAttribute("data-gf-line-qty") === "minus" && quantityForLine(key) <= 1) {
          changeLine(key, 0);
          return;
        }
        var delta = lineBtn.getAttribute("data-gf-line-qty") === "plus" ? 1 : -1;
        changeLine(key, Math.max(0, quantityForLine(key) + delta));
      }
      } catch (error) {
        showToast(error.message || "Die Seite hat einen Bedienfehler.");
      }
    });

    document.addEventListener("submit", function (event) {
      var checkoutForm = event.target.closest("[data-gf-checkout-form]");
      if (checkoutForm) {
        var submitter = event.submitter || qs("[data-gf-checkout]", checkoutForm);
        if (submitter && submitter.name && submitter.name !== "checkout" && !submitter.hasAttribute("data-gf-checkout")) {
          return;
        }
        if (checkoutHandoff) return;
        event.preventDefault();
        beginNativeCheckout(checkoutForm, submitter);
        return;
      }

      var zipForm = event.target.closest("[data-gf-zip-form]");
      if (zipForm) {
        event.preventDefault();
        var input = qs("[data-gf-zip]", zipForm);
        var placeSelect = qs("[data-gf-place]", zipForm.parentElement) || qs("[data-gf-place]");
        var result = validateZip(input && input.value, placeSelect && placeSelect.value);
        if (!result.ok) {
          applyZipResult(result, false);
          return;
        }
        var submitBtn = qs("[data-gf-zip-submit]", zipForm) || qs("button[type='submit']", zipForm);
        if (submitBtn) {
          submitBtn.setAttribute("aria-busy", "true");
          submitBtn.disabled = true;
        }
        applyZipResult(result, true)
          .catch(function (error) {
            showToast(error.message || "Die PLZ konnte nicht gespeichert werden. Bitte erneut versuchen.");
            renderZipMessage(null, {
              ok: false,
              message: error.message || "Die PLZ konnte nicht gespeichert werden. Bitte erneut versuchen."
            });
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.removeAttribute("aria-busy");
              submitBtn.disabled = false;
            }
          });
        return;
      }

      var addForm = event.target.closest("[data-gf-add-form]");
      if (addForm) {
        event.preventDefault();
        var addBtn = qs("[data-gf-add]", addForm);
        addVariant(addBtn && addBtn.getAttribute("data-variant-id"), addBtn);
        return;
      }

      var productForm = event.target.closest("[data-product-form]");
      if (productForm) {
        var addBtn = qs("[data-add-to-cart]", productForm);
        if (addBtn && addBtn.getAttribute("aria-busy") === "true") {
          event.preventDefault();
          return;
        }
        if (addBtn) {
          addBtn.setAttribute("aria-busy", "true");
          window.setTimeout(function () { addBtn.removeAttribute("aria-busy"); }, 8000);
        }
      }

      var newsletter = event.target.closest(".footer__newsletter-form");
      if (newsletter) {
        var button = newsletter.querySelector("[type='submit']");
        if (button) {
          button.classList.add("is-loading");
          button.setAttribute("aria-busy", "true");
        }
      }
    }, true);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeFulfillment();
        closeOptionDialog();
      }
      var tab = event.target.closest && event.target.closest("[data-gf-tab]");
      if (!tab || (event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "Home" && event.key !== "End")) return;
      var tabs = qsa("[data-gf-tab]");
      var index = tabs.indexOf(tab);
      if (index < 0) return;
      event.preventDefault();
      var next = index;
      if (event.key === "ArrowLeft") next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = tabs.length - 1;
      tabs[next].focus({ preventScroll: true });
      tabs[next].click();
    });

    document.addEventListener("change", function (event) {
      if (event.target && event.target.matches("[data-gf-place]")) {
        var zip = zipInputValue();
        var result = validateZip(zip, event.target.value);
        if (result.ok) {
          applyZipResult(result, true).catch(function (error) {
            showToast(error.message || "Der Ort konnte nicht gespeichert werden.");
          });
        } else {
          applyZipResult(result, false);
        }
        return;
      }
      if (!event.target || !event.target.matches("[data-cart-item-quantity]")) return;
      scheduleRailSync();
    });

    document.addEventListener("input", function (event) {
      if (event.target && event.target.matches("[data-gf-zip]")) {
        var typed = String(event.target.value || "").trim();
        qsa("[data-gf-zip]").forEach(function (field) {
          if (field !== event.target) field.value = typed;
        });
        if (currentMode() === "delivery") {
          var storedZip = ((config().attributes || {})[ATTR_ZIP]) || storedValue(ZIP_KEY);
          if (storedZip && typed !== storedZip) {
            storedSet(ZIP_KEY, "");
            storedSet(PLACE_KEY, "");
            if (window.gfOrder && window.gfOrder.attributes) {
              window.gfOrder.attributes[ATTR_ZIP] = "";
              window.gfOrder.attributes[ATTR_PLACE] = "";
            }
            hidePlaceSelects();
            syncAttributeFields("delivery", "", "");
            qsa("[data-gf-mode-place]").forEach(function (node) { node.textContent = "Ort wählen"; });
            window.clearTimeout(invalidateZipTimer);
            invalidateZipTimer = window.setTimeout(function () {
              persistMode("delivery", "", "").catch(function () {});
            }, 280);
          }
        }
      }
      if (event.target && event.target.matches("[data-gf-search]")) {
        filterMenu(event.target.value);
      }
      if (event.target && event.target.matches("[data-cart-note]")) {
        var value = event.target.value.slice(0, 500);
        qsa("[data-cart-note]").forEach(function (field) {
          if (field !== event.target) field.value = value;
        });
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          persistNote(value).catch(function (error) {
            showToast(error.message || "Der Hinweis konnte nicht gespeichert werden.");
          });
        }, 450);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" || !event.target || !event.target.matches("[data-gf-search]")) return;
      event.preventDefault();
      var menu = document.getElementById("menu");
      if (menu) menu.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
    });

    document.addEventListener("click", function (event) {
      var addBtn = event.target.closest("[data-add-to-cart]");
      if (addBtn && addBtn.getAttribute("aria-busy") === "true") {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    document.addEventListener("productAddedToCart", function () {
      qsa("[data-add-to-cart][aria-busy='true']").forEach(function (button) {
        button.removeAttribute("aria-busy");
      });
      showToast("Hinzugefügt");
      getCart().then(applyCartState).catch(function () { refreshOrderBar(); });
    });
  }

  function bindLiveSearch() {
    var input = qs("[data-popup='search'] input[name='q']");
    var results = qs("[data-gf-predictive]");
    if (!input || !results) return;
    var timer = null;
    input.addEventListener("input", function () {
      window.clearTimeout(timer);
      var query = input.value.trim();
      if (!query) {
        results.hidden = true;
        results.innerHTML = "";
        return;
      }
      timer = window.setTimeout(function () {
        fetch(routes().searchSuggest + (routes().searchSuggest.indexOf("?") >= 0 ? "&" : "?") + "q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=8", {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" }
        })
          .then(parseJSONResponse)
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            if (!products.length) {
              results.innerHTML = '<p class="gf-predictive__empty">Keine Gerichte zu „' + escapeHtml(query) + "“ gefunden.</p>";
              results.hidden = false;
              return;
            }
            results.innerHTML = products.map(function (product) {
              return '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title || "") + "</a>";
            }).join("");
            results.hidden = false;
          })
          .catch(function () {
            results.innerHTML = '<p class="gf-predictive__empty">Suche gerade nicht erreichbar. Bitte die Suchseite nutzen.</p>';
            results.hidden = false;
          });
      }, 180);
    });
  }

  function bindOffline() {
    var banner = qs("[data-gf-offline]");
    if (!banner) return;
    function sync() {
      banner.classList.toggle("is-visible", !navigator.onLine);
      banner.hidden = navigator.onLine;
    }
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    sync();
  }

  function bindTabObserver() {
    var groups = qsa("[data-gf-group]");
    if (!groups.length) return;
    if (bindTabObserver.onScroll) {
      window.removeEventListener("scroll", bindTabObserver.onScroll);
    }
    bindTabObserver.onScroll = function () {
      if (bindTabObserver.raf) return;
      bindTabObserver.raf = window.requestAnimationFrame(function () {
        bindTabObserver.raf = 0;
        updateActiveTabFromScroll();
      });
    };
    window.addEventListener("scroll", bindTabObserver.onScroll, { passive: true });
    updateActiveTabFromScroll();
    var hash = (location.hash || "").replace("#", "");
    if (!bindTabObserver.hashConsumed && hash && document.getElementById(hash)) {
      bindTabObserver.hashConsumed = true;
      window.setTimeout(function () { scrollToGroup(hash, false); }, 50);
    }
  }

  function initSeoAccordions() {
    qsa("[data-gf-seo-item]").forEach(function (item) {
      if (item.querySelector("details")) return;
      var title = qs("[data-gf-seo-title]", item);
      var body = qs("[data-gf-seo-body]", item);
      if (!title || !body) return;
      var details = document.createElement("details");
      var summary = document.createElement("summary");
      summary.textContent = title.textContent;
      title.setAttribute("hidden", "");
      details.appendChild(summary);
      details.appendChild(body);
      item.appendChild(details);
    });
  }

  function observeHeader() {
    if (!window.ResizeObserver) return;
    var header = qs(".header-wrapper");
    var nav = qs(".gf-menu__nav");
    if (observeHeader.ro) observeHeader.ro.disconnect();
    observeHeader.ro = new ResizeObserver(updateOffsets);
    if (header) observeHeader.ro.observe(header);
    if (nav) observeHeader.ro.observe(nav);
  }

  function observeDrawerCart() {
    var wrapper = qs("[data-cart-items]");
    if (!wrapper || !window.MutationObserver) return;
    if (observeDrawerCart.mo) observeDrawerCart.mo.disconnect();
    observeDrawerCart.mo = new MutationObserver(function () {
      scheduleRailSync();
    });
    observeDrawerCart.mo.observe(wrapper, { childList: true });
  }

  function watchCheckoutAvailability() {
    if (watchCheckoutAvailability.bound || !window.MutationObserver) return;
    watchCheckoutAvailability.bound = true;
    var reenable = function () {
      if (watchCheckoutAvailability.updating) return;
      var count = parseInt((qs("[data-cart-count]") || {}).textContent, 10) || 0;
      if (count <= 0) return;
      watchCheckoutAvailability.updating = true;
      setCheckoutEnabled(true);
      watchCheckoutAvailability.updating = false;
    };
    var observer = new MutationObserver(reenable);
    qsa("[data-gf-checkout], [data-checkout-button], [data-cart]").forEach(function (node) {
      observer.observe(node, { attributes: true, attributeFilter: ["disabled", "class"] });
    });
    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(reenable, 50);
    });
  }

  function scrubLegacyZip(state) {
    var attrs = (state && state.attributes) || {};
    var zip = attrs[ATTR_ZIP];
    var place = attrs[ATTR_PLACE];
    var mode = currentMode();
    if (LEGACY_ZIP_VALUES[zip] === true || (mode === "pickup" && (zip || place))) {
      persistMode(mode === "pickup" ? "pickup" : "delivery", "", "")
        .then(function () { setModeUI(mode === "pickup" ? "pickup" : "delivery"); })
        .catch(function () {});
      return;
    }
    if (mode === "delivery" && zip) {
      var result = validateZip(zip, place);
      if (!result.ok) {
        persistMode("delivery", "", "")
          .then(function () { setModeUI("delivery"); })
          .catch(function () {});
      }
    }
  }

  function maybePromptFulfillment() {
    var attr = ((config().attributes || {})[ATTR_MODE]) || "";
    if (modeWasChosen() || attr === "Lieferung" || attr === "Abholung") return;
    if (!window.matchMedia("(max-width: 749px)").matches) return;
    var panel = qs("[data-gf-fulfillment]");
    var overlay = qs("[data-gf-fulfillment-overlay]");
    var toggle = qs("[data-gf-open-fulfillment]");
    if (!panel) return;
    panel.classList.add("is-open", "gf-fulfillment--prompt");
    panel.setAttribute("aria-modal", "true");
    document.documentElement.classList.add("gf-fulfillment-prompt");
    if (overlay) overlay.classList.add("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
    var focusable = qs("button[data-gf-mode], button, input", panel);
    if (focusable) window.setTimeout(function () { focusable.focus(); }, 30);
  }

  function bindFaq() {
    qsa("[data-gf-faq], .gf-faq__item").forEach(function (item) {
      var summary = item.querySelector("summary");
      if (!summary) return;
      summary.setAttribute("aria-expanded", item.open ? "true" : "false");
      if (item.__gfFaqBound) return;
      item.__gfFaqBound = true;
      item.addEventListener("toggle", function () {
        summary.setAttribute("aria-expanded", item.open ? "true" : "false");
      });
    });
  }

  function setCartChrome(open) {
    var main = qs("#MainContent");
    var footer = qs("footer");
    var orderbar = qs("[data-gf-orderbar]");
    [main, footer].forEach(function (node) {
      if (!node) return;
      if (open) node.setAttribute("inert", "");
      else node.removeAttribute("inert");
    });
    if (orderbar) orderbar.toggleAttribute("inert", open);
    document.documentElement.classList.toggle("gf-cart-open", open);
  }

  function bindCartDrawerA11y() {
    var stage = qs("[data-popup-stage='cart']");
    var dialog = qs("[data-popup='cart']");
    if (!stage || !dialog || bindCartDrawerA11y.bound) return;
    bindCartDrawerA11y.bound = true;
    var lastOpener = null;
    document.addEventListener("click", function (event) {
      var opener = event.target.closest && event.target.closest("[data-popup-open='cart']");
      if (opener) lastOpener = opener;
    }, true);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        setCartChrome(stage.classList.contains("is-open"));
      }).observe(stage, { attributes: true, attributeFilter: ["class"] });
    }
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!stage.classList.contains("is-open")) return;
      var closer = qs("[data-popup-close='cart'][data-cart-close], [data-popup-close='cart']");
      if (closer) closer.click();
      if (lastOpener && lastOpener.focus) window.setTimeout(function () { lastOpener.focus(); }, 20);
    });
  }

  function syncSearchDetails() {
    var wrap = qs(".gf-menu__search-wrap");
    if (!wrap) return;
    if (!wrap.__gfSearchBound) {
      wrap.__gfSearchBound = true;
      wrap.addEventListener("toggle", function () {
        if (wrap.open) wrap.setAttribute("data-user-open", "");
        else wrap.removeAttribute("data-user-open");
      });
    }
    if (window.matchMedia("(min-width: 750px)").matches) wrap.setAttribute("open", "");
    else if (!wrap.hasAttribute("data-user-open")) wrap.removeAttribute("open");
  }

  function hydrate() {
    updateOffsets();
    syncSearchDetails();
    enableDesktopRail();
    setModeUI(currentMode());
    if (isDeliveryConfirmed()) {
      qsa("[data-gf-zip]").forEach(function (input) {
        if (isPlaceholderZip(input.value)) input.value = currentZip();
      });
    }
    filterMenu((qs("[data-gf-search]") || {}).value || "");
    bindTabObserver();
    initSeoAccordions();
    bindFaq();
    refreshOrderBar();
    observeHeader();
    watchExpressHeader();
    neutralizeExpressHeader();
    observeDrawerCart();
    watchCheckoutAvailability();
    watchInjectedCheckoutWidgets();
    stripInjectedCheckoutWidgets();
    getCart().then(function (state) {
      applyAttributeState(state);
      applyCartState(state);
      scrubLegacyZip(state);
      applyQueryMode();
      var attrs = (state && state.attributes) || {};
      if (attrs[ATTR_MODE]) {
        markModeChosen();
        setModeUI(currentMode());
      } else if (modeWasChosen()) {
        var mode = currentMode();
        var confirmed = mode === "delivery" && isDeliveryConfirmed();
        persistMode(mode, confirmed ? currentZip() : "", confirmed ? currentPlace() : "")
          .then(function () { setModeUI(currentMode()); })
          .catch(function () {});
      } else {
        maybePromptFulfillment();
      }
    }).catch(function () {});
  }

  function applyQueryMode() {
    try {
      var params = new URLSearchParams(location.search);
      var query = String(params.get("bestellart") || "").toLowerCase();
      if (query !== "abholung") return;
      persistMode("pickup", "", "")
        .then(function () { setModeUI("pickup"); })
        .catch(function () {});
      params.delete("bestellart");
      var next = location.pathname + (params.toString() ? "?" + params.toString() : "") + location.hash;
      if (window.history && history.replaceState) history.replaceState({}, "", next);
    } catch (error) {}
  }

  function bindNewsletter() {
    var form = qs(".footer__newsletter-form");
    if (!form || bindNewsletter.bound) return;
    bindNewsletter.bound = true;
    form.addEventListener("submit", function () {
      var btn = qs("[type='submit']", form);
      if (btn) {
        btn.setAttribute("aria-busy", "true");
        btn.disabled = true;
      }
    });
    var status = qs("[data-form-status]", form);
    if (status) status.focus();
  }

  function startOrderPage() {
    bindDelegatedEvents();
    bindLiveSearch();
    bindOffline();
    bindCartDrawerA11y();
    bindNewsletter();
    hydrate();
    window.addEventListener("resize", function () {
      updateOffsets();
      syncSearchDetails();
      enableDesktopRail();
    });
    window.addEventListener("orientationchange", function () {
      window.setTimeout(updateOffsets, 300);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateOffsets).catch(function () {});
    }
    document.addEventListener("shopify:section:load", hydrate);
    document.addEventListener("shopify:section:reorder", updateOffsets);
    document.addEventListener("shopify:section:unload", updateOffsets);
    document.addEventListener("shopify:block:select", updateOffsets);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startOrderPage);
  } else {
    startOrderPage();
  }
})();
